// Lưu/khôi phục tiến độ PHIẾU HỌC TẬP (câu tự luận ngắn + tự đánh giá Đạt/Chưa) theo TÀI KHOẢN.
// Fetch 1 lần/bài (cache), ghi lên server có debounce. Chưa đăng nhập → im lặng (không lưu).
import { API_CONFIG } from '../../../config/api.config'

const BASE = `${API_CONFIG.python.apiUrl}/lesson-builder`
const token = () =>
  localStorage.getItem('jwt_token') || localStorage.getItem('auth_token') || localStorage.getItem('token') || ''

export interface WsAnswer { answer: string; self_assess: string }

const cache = new Map<string, Map<string, WsAnswer>>()          // lessonId → (item_key → {answer, self_assess})
const loading = new Map<string, Promise<Map<string, WsAnswer>>>()
const timers = new Map<string, ReturnType<typeof setTimeout>>()

async function fetchAnswers(lessonId: string): Promise<Map<string, WsAnswer>> {
  const m = new Map<string, WsAnswer>()
  try {
    const res = await fetch(`${BASE}/lessons/${lessonId}/worksheet-answers`, {
      headers: { Authorization: `Bearer ${token()}` },
    })
    if (res.ok) {
      const data = await res.json()
      for (const it of data.items || []) {
        m.set(it.item_key, { answer: it.answer || '', self_assess: it.self_assess || '' })
      }
    }
  } catch { /* offline → coi như chưa có */ }
  cache.set(lessonId, m)
  return m
}

// Nạp toàn bộ câu trả lời của bài (gọi 1 lần; các component chờ Promise này rồi đọc getCached).
export function loadWorksheet(lessonId?: string): Promise<Map<string, WsAnswer>> {
  if (!lessonId || !token()) return Promise.resolve(new Map())
  if (!loading.has(lessonId)) loading.set(lessonId, fetchAnswers(lessonId))
  return loading.get(lessonId)!
}

export function getCached(lessonId: string | undefined, key: string): WsAnswer | undefined {
  if (!lessonId) return undefined
  return cache.get(lessonId)?.get(key)
}

// Lưu 1 khối (upsert). answer → debounce; self_assess → nên gọi debounceMs=0 (lưu ngay).
export function saveWorksheet(
  lessonId: string | undefined,
  key: string,
  patch: Partial<WsAnswer>,
  debounceMs = 700,
): void {
  if (!lessonId || !token()) return
  let m = cache.get(lessonId)
  if (!m) { m = new Map(); cache.set(lessonId, m) }
  const cur = m.get(key) || { answer: '', self_assess: '' }
  m.set(key, { answer: patch.answer ?? cur.answer, self_assess: patch.self_assess ?? cur.self_assess })

  const tkey = `${lessonId}::${key}`
  const prev = timers.get(tkey)
  if (prev) clearTimeout(prev)
  const doPost = () => {
    fetch(`${BASE}/lessons/${lessonId}/worksheet-answers`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ item_key: key, ...patch }),
    }).catch(() => { /* im lặng; cache vẫn giữ để lần sau thử lại */ })
  }
  if (debounceMs <= 0) doPost()
  else timers.set(tkey, setTimeout(doPost, debounceMs))
}
